module.exports = {"xmlns":"http://www.w3.org/2000/svg","width":24,"height":24,"viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":2,"stroke-linecap":"round","stroke-linejoin":"round"}


//////////////////
// WEBPACK FOOTER
// ./src/default-attrs.json
// module id = 87
// module chunks = 0